<template>
  <div>
    <div class="card">
      <img v-lazy="item.evaluation.classify_image" class="testImg" />
      <div class="detail">
        <p class="h2">{{ item.evaluation.title }}</p>
        <span class="f10 fr mr-10 mt-5">{{ item.evaluation.time }}</span>
        <p
          class="btn f14 tac fff"
          @click="goEval(item.evaluation.id, item.id)"
          v-if="flag === 0"
          style="width: 50%"
        >
          留下你的评价吧
        </p>
        <p
          class="btn f14 tac fff"
          @click="goRes(item.id, item.evaluation.id)"
          v-if="flag === 1"
        >
          查看
        </p>
        <span>{{ item.finish_time.split(" ")[0] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/index";
export default {
  name: "Card",
  props: {
    item: Object,
    flag: Number,
  },
  data() {
    return {};
  },
  methods: {
    // 评价
    goEval(id, testId) {
      store.commit("set_appraisal_id", id);
      store.commit("set_eval_id", testId);
      this.$router.push("/test/" + id + "/comment");
    },
    // 查看结果
    goRes(testId, id) {
      store.commit("set_appraisal_id", id);
      store.commit("set_eval_id", testId);
      this.$router.push("/test/" + testId + "/mycomment");
    },
  },
};
</script>

<style lang='less' scoped>
.card {
  width: 100%;
  .testImg {
    width: 32%;
    height: 96px;
    border-radius: 12px;
    margin: 10px;
  }
  .detail {
    float: right;
    width: 60%;
    margin-right: 10px;
    font-size: 15px;
    margin-top: 20px;
    .h2 {
      height: 70px;
      line-height: 0.6rem;
    }
    .btn {
      width: 33%;
      border-radius: 8px;
      line-height: 20px;
      background-color: #42686e;
    }
    span {
      float: right;
      margin-top: -0.3rem;
      font-size: smaller;
      color: #9b9b9b;
    }
  }
}
</style>
<style lang='less'>
.van-tab--active {
  .van-tab__text {
    color: #42686e;
  }
}
.van-tabs__line {
  background-color: #42686e;
  /*width: 100%;*/
}
</style>